<template>
  <div class="row">
    <div class="col-md-3 mb-4 p-2 shadow bg-white">
      <b-list-group>
        <b-list-group-item
          @click="changeSection('geral')"
          to="/dashboard/admin/settings/general"
          >{{ $t("General") }}</b-list-group-item
        >
        <b-list-group-item
          @click="changeSection"
          to="/dashboard/admin/settings/appearance"
          >{{ $t("Appearance") }}</b-list-group-item
        >
        <b-list-group-item
          @click="changeSection"
          to="/dashboard/admin/settings/localization"
          >{{ $t("Localization") }}</b-list-group-item
        >
        <b-list-group-item
          v-if="$store.state.user.role_details.name == 'Admin'"
          @click="changeSection"
          to="/dashboard/admin/settings/authentication"
          >{{ $t("Authentication") }}</b-list-group-item
        >
        <b-list-group-item
          @click="changeSection"
          to="/dashboard/admin/settings/mail"
          >{{ $t("Mail") }}</b-list-group-item
        >
      </b-list-group>
      <b-list-group-item
        v-if="$store.state.user.role_details.name == 'Admin'"
        @click="changeSection"
        to="/dashboard/admin/settings/rma"
      >
        RMA
      </b-list-group-item>
    </div>
    <div class="col-md-9">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  metaInfo() {
    return {
      title: this.$i18n.t("Settings"),
    };
  },
  mounted() {
    this.getSettings();
    this.getDomains();
  },
  data() {
    return {
      settings: {
        app_name: null,
        app_keywords: null,
        app_description: null,
        app_domain: null,
        only_primary_domain: false,
        app_logotipo: null,
        app_icon: null,
        app_background: null,
        homepage_enabled: null,
        homepage_description: null,
        app_default_color: null,
        app_timezone: null,
        app_locale: null,
        app_date_locale: null,
        app_date_format: null,
        app_register: null,
        app_suporte_email: null,
        app_suporte_password: null,
        app_suporte_url: null,
        registration_to_display: false,
        unverified_user_alert: false,
        mail_mailer: "log",
        mail_encryption: null,
        mail_from_address: null,
        mail_from_name: null,
        mail_host: null,
        mail_password: null,
        mail_port: null,
        mail_username: null,
        app_estado: null,
        app_cidade: null,
        autorizar_concessao: false,
        dias_validade_senha: null,
        password_reset: null
      },
      dataSettings: {},
      domains: [],
      loading: true,
    };
  },
  methods: {
    // Get settings data
    getSettings() {
      // Get all settings values
      axios
        .get("api/dashboard/settings")
        .then((response) => {
          response.data.data.forEach((obj) => {
            this.settings[obj.key] = obj.value;
            this.dataSettings[obj.key] = obj.value;

            if (obj.key === "password_reset") {
              this.settings[obj.key] = obj.value === "1" ? true : false;
              this.dataSettings[obj.key] = obj.value === "1" ? true : false;
            }
          });
          if (this.settings.app_estado) {
            this.$root.$emit("estadoSelecionado", this.settings.app_estado.id);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDomains() {
      axios.get("api/dashboard/settings/domains").then((response) => {
        this.domains = response.data.data;
      });
    },
    // Save settings
    updateSettings() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      // Send new settings
      axios
        .post("api/dashboard/settings", {
          type: "settings",
          settings: this.settings,
        })
        .then((response) => {
          // Reload new settings
          this.getSettings();
          // Update window.config data
          window.config.name = this.settings.app_name;
          window.config.description = this.settings.app_description;
          window.config.default_color = this.settings.app_default_color;
          window.config.register = this.settings.app_register;
          window.config.date_locale = this.settings.app_date_locale;
          window.config.date_format = this.settings.app_date_format;
          window.config.autorizar_concessao = this.settings.autorizar_concessao;
          window.config.unverified_user_alert =
            this.settings.unverified_user_alert;
          // Change app language
          if (document.documentElement.lang !== this.settings.app_locale) {
            document.documentElement.lang = this.settings.app_locale;
            this.$i18n.locale = this.settings.app_locale;
            axios.get("api/lang/" + this.$i18n.locale).then((response) => {
              this.$i18n.setLocaleMessage(
                this.$i18n.locale,
                response.data.data
              );
            });
          }
          // Update vuex
          this.$store.commit("setSettings", window.config);
          // Send success state
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
    // Set default data on change page
    changeSection() {
      this.settings = Object.assign({}, this.dataSettings);
    },
  },
};
</script>
